/**
 * Theme-aware wrapper for the shared segment contrast guard (MP-182).
 *
 * The guard must evaluate writer colors against the surface the transcript is
 * actually painted on — the viewer's own background/text settings — not the
 * app's global light/dark chrome. Pass the live viewer settings colors; the
 * returned guard recomputes whenever they change.
 */

import { legibleSegmentColors, type SegmentColorResult } from '@polygraf/shared'
import { useCallback } from 'react'

export function useSegmentColorGuard(
	backgroundColor: string,
	textColor: string,
): (color: string | undefined, backgroundColor: string | undefined) => SegmentColorResult {
	return useCallback(
		(color, segmentBackgroundColor) =>
			legibleSegmentColors(color, segmentBackgroundColor, {
				themeBg: backgroundColor,
				themeText: textColor,
			}),
		[backgroundColor, textColor],
	)
}
